import DiscoverTheAppOfTheYear from './DiscoverTheAppOfTheYear';

export default DiscoverTheAppOfTheYear;
